import { useMemo } from 'react';
import { Page } from '@components/layout/Page';
import { getDashboardModules } from '@components/layout/nav.config';
import { useAuth } from '@features/auth/hooks';
import { ModuleCard } from './components/ModuleCard';

export default function HomeScreen() {
  const { user, profile, roles } = useAuth();

  const greetingName =
    profile?.firstName ?? user?.displayName ?? user?.email?.split('@')[0] ?? 'there';

  const today = useMemo(
    () =>
      new Date().toLocaleDateString(undefined, {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
      }),
    [],
  );

  const modules = useMemo(() => getDashboardModules(roles), [roles]);

  const title = `Welcome back, ${greetingName}`;

  return (
    <Page
      eyebrow={`Workspace · ${today}`}
      title={title}
      titleAccent={greetingName}
      subtitle="Pick a module to get started. Greyed-out modules are on the roadmap."
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {modules.map(({ section, item }) => (
          <ModuleCard key={item.to} section={section} item={item} />
        ))}
      </div>
    </Page>
  );
}
